import {h, Fragment} from "preact"
import { defaultConfig } from "../config"

export default function Skeleton() {
    return (
        <div class="ns-skeleton cls-placeholder">
            <section class="collection-toolbar">
                <div class="toolbar-left">
                <div class="toolbar-left__text">Show Filters <span class="icon">+</span></div>
                </div>
                <div class="toolbar-center">
                    <div class="view-toggle">
                        <button class="view-btn" aria-label="List View" style="aspect-ratio: 3 / 4;"></button>
                        <button class="view-btn" aria-label="2-column Grid" style="aspect-ratio: 3 / 4;"></button>
                        <button class="view-btn" aria-label="3-column Grid" style="aspect-ratio: 3 / 4;"></button>
                    </div>
                    <div class="view-toggle">
                        <button type="button" class="view-btn active" aria-label="List View" style="aspect-ratio: 3 / 4;" style='pointer-events: none; cursor: pointer;'></button>
                        <button type="button" class="view-btn active" aria-label="2-column Grid" style="aspect-ratio: 3 / 4;" style='pointer-events: none; cursor: pointer;'></button>
                        <button type="button" class="view-btn active" aria-label="3-column Grid" style="aspect-ratio: 3 / 4;" style='pointer-events: none; cursor: pointer;'></button>
                        <button type="button" class="view-btn active" aria-label="4-column Grid" style="aspect-ratio: 3 / 4;" style='pointer-events: none; cursor: pointer;'></button>
                    </div>
                </div>
                <div class="toolbar-right ns-toolbar-btn-text">
                    <div class="toolbar-right__text">Sort By <span class="icon">+</span></div>
                </div>
            </section>

            <div class="responsive-image-grid">
                {Array.from({ length: defaultConfig.serpSize }, (_, i) => (
                    <div class="grid-item" key={i}>
                        <div class="grid-image-custom-placeholder" style="aspect-ratio: 3 / 4;" />
                    </div>
                ))}
            </div>
        </div>
    )
}